<template>
  <span
    class="flex h-4 w-10 items-center justify-center rounded-full px-1 py-0-25 text-xxs leading-none font-semibold tracking-wider text-white uppercase"
    :class="type === 'beta' ? 'bg-secondary-purple-1' : 'bg-success'"
  >
    {{ type === "beta" ? $t("COMMON.BETA") : $t("COMMON.NEW") }}
  </span>
</template>

<script setup lang="ts">
import type { PropType } from "vue";

defineProps({
  type: {
    type: String as PropType<"beta" | "new">,
    default: "beta",
  },
});
</script>
